import { SETUP_DISTRAINTS_BY_ID } from './constants'

export const setupDistraintsById = (id) => ({
    type: SETUP_DISTRAINTS_BY_ID,
    data: { id },
})
